import React, { Component } from "react";
import { AiOutlineHtml5 } from "react-icons/ai";
import { DiCss3Full } from "react-icons/di";
import { DiReact } from "react-icons/di";
import { DiJavascript1 } from "react-icons/di";
import { SiRedux } from "react-icons/si";
import { DiBootstrap } from "react-icons/di";
import { SiMaterialUi } from "react-icons/si";

import { DiNodejsSmall } from "react-icons/di";
import { DiMongodb } from "react-icons/di";
import { DiGithubBadge } from "react-icons/di";

import style from "./Resume.module.css";

class Resume extends Component {
  render() {
    if (this.props.data) {
      var education = this.props.data.education.map(function (education) {
        return (
          <div key={education.school}>
            <h3>{education.school}</h3>
            <p className="info">
              {education.degree} <span>&bull;</span>
              <em className="date">{education.graduated}</em>
            </p>
            <p>{education.description}</p>
          </div>
        );
      });
    }

    return (
      <section id="resume">
        <div className="row education">
          <div className="three columns header-col">
            <h1>
              <span>Education</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">{education}</div>
            </div>
          </div>
        </div>

        <div className="row skill">
          <div className="three columns header-col">
            <h1>
              <span>Skills</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <section id="four" className="skills">
              <div className="languages skills show-on-scroll">
                <div>
                  {" "}
                  <div
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                    
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <AiOutlineHtml5 />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>HTML</p>
                </div>

                <div>
                  <div
                    className={style.newDiv}
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <DiCss3Full />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>CSS</p>
                </div>
                <div>
                  <div
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <DiReact />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>React</p>
                </div>
                <div>
                  {" "}
                  <div
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <DiJavascript1 />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>Javascript</p>
                </div>
                <div>
                  <div
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <SiRedux />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>Redux</p>
                </div>
                <br />
                <div>
                  {" "}
                  <div
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <DiNodejsSmall />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>Node Js</p>
                </div>
                <div>
                  {" "}
                  <div
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <DiMongodb />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>MongoDB</p>
                </div>
                <div>
                  <div
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <DiGithubBadge />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>GitHub</p>
                </div>
                <div>
                  {" "}
                  <div
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <DiBootstrap />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>BootStrap</p>
                </div>

                <div>
                  {" "}
                  <div
                    className={style.newDiv}
                    style={{
                      height: "100px",
                      width: "100px",
                      color: "black",
                      border: "1px solid black",
                      padding: "10px",
                      margin: "10px",
                      boxShadow: "0px 2px 5px rgb(17, 171, 176)",
                    }}
                  >
                    <SiMaterialUi />
                  </div>
                  <p style={{ fontSize: "15px", color: "black" }}>
                    Material Ui
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    );
  }
}

export default Resume;
